import React, {Fragment} from 'react';
import Box from '../layout/Box';
import Button from "../form/Button";
import TextInput from '../form/TextInput';
import ComponentConfig from '../form/ComponentConfig';
import ComponentLoader from '../form/ComponentLoader';
import AddressControl from '../form/AddressControl';
import Select from '../form/Select';
import { saveComponent } from '../../utils/components';
import { loginUser } from '../../actions';
import { connect } from 'react-redux';
import {isEqual} from "lodash-es";

class CurrentUserEditor extends React.Component {

    render() {
        return (
            <ComponentConfig componentName="currentuser">
                <ComponentLoader ref={(el) => this.loader = el} componentName="currentuser" view="admin_editor">
                    <CurrentUserForm {...this.props} reloadForm={() => this.loader && this.loader.loadComponent()} />
                </ComponentLoader>
            </ComponentConfig>
        );
    }
}

class CurrentUserForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dirty: false,
            isLoading: false,
            values: props.values
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual(prevProps.values, this.props.values)) {
            this.setState({values: this.props.values});
        }
    }

    saveForm = async () => {
        this.setState({isLoading: true});
        let data = this.state.values;
        if (this.state.values.password !== undefined && !this.state.values.password) {
            delete data.password;
        }
        let resp = await saveComponent("currentuser", data, "moddata");
        if (resp.success) {
            this.props.loginUser({detach: false});
            this.props.reloadForm();
            this.setState({isLoading: false, dirty: false});
        }

    }

    setFieldValue = async (field, value) => {
        let newValues = this.state.values;
        newValues[field] = value;
        this.setState({values: newValues, dirty: true});
    }

    render () {
        return (
            <Box
                theme="default"
                header="Profil"
                footer={[
                    <Button
                        key="0"
                        disabled={!this.state.dirty || this.state.isLoading}
                        color="primary"
                        className="pull-right"
                        onClick={this.saveForm}
                    >
                        Mentés
                    </Button>
                ]}
            >
                <form>
                    <div className="row form-row">
                        <div className="col-sm-3">
                            <TextInput
                                name="id"
                                value={this.state.values.id}
                                label="Kód"
                                role="idfield"
                            />
                        </div>
                        <div className="col-sm-3">
                            <TextInput
                                name="lastname"
                                value={this.state.values.lastname}
                                label="Vezetéknév"
                                saveChanges={this.setFieldValue}
                            />
                        </div>
                        <div className="col-sm-3">
                            <TextInput
                                name="firstname"
                                value={this.state.values.firstname}
                                label="Keresztnév"
                                saveChanges={this.setFieldValue}
                            />
                        </div>
                        <div className="col-sm-3">
                            <TextInput
                                name="nickname"
                                label="Becenév"
                                value={this.state.values.nickname}
                                saveChanges={this.setFieldValue}
                            />
                        </div>
                    </div>
                    <div className="row form-row">
                        <div className="col-md-6">
                            <TextInput
                                name="telnum"
                                label="Telefonszám"
                                value={this.state.values.telnum}
                                saveChanges={this.setFieldValue}
                            />
                        </div>
                        <div className="col-md-6">
                            <TextInput
                                name="email"
                                label="E-mail-cím"
                                value={this.state.values.email}
                                saveChanges={this.setFieldValue}
                            />
                        </div>
                    </div>
                    <div className="row form-row">
                        <AddressControl
                            value={this.state.values.address}
                            label="Cím"
                            saveChanges={this.setFieldValue}
                        />
                    </div>
                    <div className="row form-row">
                        <div className="col-md-6">
                            <Select
                                label="Partner"
                                name="partner"
                                component="partner"
                                objectValue={true}
                                isClearable={true}
                                labelKey="name"
                                valueKey="partner_id"
                                storeType="remote"
                                value={this.state.values.partner}
                                saveChanges={this.setFieldValue}
                            />
                        </div>
                    </div>
                    <div className="row form-row">
                        <div className="col-md-6">
                            <label htmlFor="pw-input" className="control-label" >Jelszó</label>
                            <input
                                id="pw-input"
                                name="password"
                                type="password"
                                value={this.state.values.password}
                                onChange={(e) => this.setFieldValue("password", e.target.value)}
                                className="p-inputtext p-component form-control"
                            />
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="pwagain-input" className="control-label" >Jelszó még egyszer</label>
                            <input
                                id="pwagain-input"
                                name="passwordagain"
                                type="password"
                                value={this.state.values.passwordagain}
                                onChange={(e) => this.setFieldValue("passwordagain", e.target.value)}
                                className="p-inputtext p-component form-control"
                            />
                        </div>
                    </div>
                </form>
            </Box>
        )
    }
}
export default connect((state) => {
    return {};
}, {loginUser})(CurrentUserEditor);